import React, { useEffect, useState } from 'react';
import DataTable, { DataTableColumn } from '../Components/DataTable';
import { FixtureOdds } from './FixtureOverviewModels';
import CreateRoundUtil from '../CreateRound/CreateRoundUtil';
import RoundOverviewUtil from '../RoundOverview/RoundOverviewUtil';
import { green, yellow } from '@material-ui/core/colors';
import { Box, Button, Link } from '@material-ui/core';
import { Link as RouterLink } from "react-router-dom";
import { formatNumber } from '../common/helpers/CurrencyHelpers';

interface FixtureOddsTableProps {
    items: FixtureOdds[];
    onSelect? : (item : FixtureOdds) => void;
    ngMode?: boolean;
}

const FixtureOddsTable: React.FC<FixtureOddsTableProps> = (props) => {
    const [selectedId, setSelectedId] = useState<string>("");
    const [columns, setColumns] = useState<DataTableColumn<FixtureOdds>[]>([]);
 
    useEffect(() => {
      refreshColumns();
    }, []);
    
    const refreshColumns = () => {
      var cols: DataTableColumn<FixtureOdds>[] = [
        { id: 'fixtureId', numeric: false, disablePadding: true, label: "Fixture Id", filterEnabled: true },
        { id: 'operatorId', numeric: false, disablePadding: true, label: "Operator Id", filterEnabled: true },
        { id: 'fetchedAt', numeric: false, disablePadding: true, label: "Fetched at", filterEnabled: true, renderValue: it => CreateRoundUtil.toDateTimeString(it.fetchedAt) },
        { id: 'oneOdds', numeric: true, disablePadding: false, label: 'One', filterEnabled: true,  renderValue: it => formatNumber(it.oneOdds, 2) },
        { id: 'xOdds', numeric: true, disablePadding: false, label: 'X', filterEnabled: true,  renderValue: it => formatNumber(it.xOdds, 2) },
        { id: 'twoOdds', numeric: true, disablePadding: false, label: 'Two', filterEnabled: true ,  renderValue: it => formatNumber(it.twoOdds, 2)},
       { id: undefined, numeric: false, disablePadding: false, label: "  ", renderValue: it => "" },
      ];

      setColumns(cols);
    }
    
    const getId = (item: FixtureOdds) : string => {
      return `${item.fixtureId}|${item.operatorId}`;
    }
    const onSelect = (item : FixtureOdds) => {
        setSelectedId(getId(item));
        if (props.onSelect){
          props.onSelect(item);
        }
    };
     return (
      <DataTable columns={columns} items={props.items} getId={getId} orderBy='operatorId' order='asc' resultFilterEnabled={true} size='xsmall' onSelect={onSelect}  />
    );
  };
  
  export default FixtureOddsTable;
 